
/* START_TEMPLATE */
define('hbs!pricelist/templates/booking',['hbs','handlebars','templates/helpers/unlessZero'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, stack2, options, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "\r\n\r\n";
  }

function program3(depth0,data) {
  
  
  return "\r\n  Information saknas.\r\n";
  }

  buffer += "<a href=\"#\" class=\"close\">&times;</a>\r\n\r\n<h3 class=\"title\">Bokning</h3>\r\n\r\n";
  options = {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data)};
  stack2 = ((stack1 = helpers.unlessZero),stack1 ? stack1.call(depth0, depth0.Bookings, options) : helperMissing.call(depth0, "unlessZero", depth0.Bookings, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_booking', t);
return t;
});
/* END_TEMPLATE */
;
